import { FormControl, FormHelperText, FormLabel, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as React from 'react';


export default function CustomTextField({ values, onChange, error, placeholder, type, title, required, rows, multiline, InputProps, disabled, subtitle, width, subtitleTop, max }) {
    const handleOnChange = (e) => {
        const value = e;
        if (type === "number") {
            const filteredValue = value.replace(/[^0-9.]/g, '');
            if (max && parseFloat(filteredValue) > max) return;
            onChange(filteredValue);
        }
        else if (type === "integer") {
            const filteredValue = value.replace(/[^0-9]/g, '');

            // Allow empty string
            if (filteredValue === "") {
                onChange("");
                return;
            }

            // Allow "0" but disallow numbers with leading zero
            if (filteredValue.length > 1 && filteredValue.startsWith("0")) {
                return;
            }

            onChange(filteredValue);
        } else if (type === "price") {
            // Allow digits and a single "."
            const filteredValue = value
                .replace(/[^0-9.]/g, '') // remove invalid chars
                .replace(/^(\d*\.\d*).*$/, '$1'); // keep only the first "."

            // Prevent multiple dots
            const dotCount = (filteredValue.match(/\./g) || []).length;
            if (dotCount > 1) return;

            if (filteredValue === "") {
                onChange(""); // allow empty
                return;
            }

            // Optional: disallow 0 or convert to float here
            onChange(filteredValue);
        } else if (type === "integer_allow_0") {
            const filteredValue = value.replace(/[^0-9]/g, '');
            onChange(filteredValue);
        } else if (type === "integer_not_allow_0") {
            const filteredValue = value.replace(/[^0-9]/g, ''); // keep only digits

            if (filteredValue === "") {
                onChange(""); // allow empty
                return;
            }

            if (parseInt(filteredValue) === 0) return; // disallow 0

            if (max && parseInt(filteredValue) > max) return;

            onChange(filteredValue);
        } else if (type === "phone") {
            const filteredValue = value.replace(/[^0-9]/g, '');
            onChange(filteredValue);
        } else {
            onChange(value);
        }
    }
    return (
        <>
            <FormControl variant="standard" fullWidth={width ? false : true} style={{ width: width && width }}>
                <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                {subtitleTop && <span style={{ fontSize: 13, color: '#74788D', marginBottom: '5px', fontWeight: '300' }}>{subtitleTop}</span>}

                <TextField
                    size="small"
                    placeholder={placeholder}
                    // type={type}
                    multiline={multiline}
                    rows={rows}
                    InputProps={InputProps}
                    required={required}
                    value={values}
                    disabled={disabled}
                    variant="outlined"
                    style={disabled ? { backgroundColor: '#F1F3F4', color: '#52525280' } : {}}
                    onChange={(e) => handleOnChange(e.target.value)}
                />
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
                {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}
            </FormControl>
        </>


    );
}
